import * as React from 'react';

export const usersNotFound = 'No users were found';
export const FETCHING_MESSAGE: JSX.Element = <p>Loading, <br/> please wait a few seconds to fetch all the data.</p>;
export const SAVING_MESSAGE: JSX.Element = <p>Saving, <br/> please wait a few seconds to save all the data.</p>;
export const VERIFICATION_MESSAGE: JSX.Element = <p>Verifying...<br/>Please wait a few seconds. </p>;
export const filespacesWereNotFound = 'No filespaces were found';
export const minimumSearchLength = 3;
export const minimumSearchLengthErrorMessage = 'Please input at least 3 characters';

const backOfficeidentityProvider = {name: 'Google', providerId: 'Google'};

export const backOfficeSignUpSites = {
    name: backOfficeidentityProvider.name,
    component: (onClick: Function) => {
        return (
            <button
                onClick={(e: any) => {
                    e.preventDefault();
                    onClick(backOfficeidentityProvider.providerId);
                }}
            >
                Sign in with {backOfficeidentityProvider.name}
            </button>
        );
    }
};


// WEBPACK FOOTER //
// ./src/backoffice/utils/constants.tsx